// global css
import 'bootstrap/dist/css/bootstrap.css'
import 'react-select/dist/react-select.css'
import 'react-datepicker/dist/react-datepicker.css'

import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import debounce from 'lodash/debounce'
import configureStore from './store/configureStore'
import App from './App'
import { saveAuth, loadAuth } from './utils/authLocalStorage'
import { getAuth } from './selectors'

const store = configureStore({
  auth: loadAuth(),
})
const storeHistory = syncHistoryWithStore(browserHistory, store)

store.subscribe(
  debounce(() => {
    saveAuth(getAuth(store.getState()))
  }, 1000),
)

const rootEl = document.getElementById('root')
render(<App store={store} history={storeHistory} />, rootEl)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    render(<NextApp store={store} history={storeHistory} />, rootEl)
  })
}



// WEBPACK FOOTER //
// ./src/index.js